export default "__VITE_ASSET__b9331b08__"